import { Api } from "@/api";
import { timed } from "@/utils/loaderLogger";
import { Cart } from "@/utils/types/types";

export const PAGE_SIZE = 20;

export type CartsData = {
  carts: Cart[];
  count: number;
  page: number;
  adminUIDs: Set<string>;
  userEmailByUID: Map<string, string>;
};

// 2026-09-03: one server call (/api/carts/list) does filter + search +
// paging in the DB. The old loader pulled EVERY WebUser (full Stytch blobs)
// just to label 20 carts, then hid empty customer carts client-side — pages
// showed ~6 rows and search only saw the current page. Filters and search
// live in the URL so page 2 of a search is a real page 2.
export default function dashboardCartsLoader({
  request,
}: {
  request: Request;
}) {
  const url = new URL(request.url);
  const page = parseInt(url.searchParams.get("page") || "1", 10);
  const search = url.searchParams.get("search") || "";
  const type = url.searchParams.get("type") || "";
  const hasItems = url.searchParams.get("hasItems") === "1";

  const data: Promise<CartsData> = timed(
    `carts.list(page:${page}${search ? ` search:${search}` : ""})`,
    Api.get<{
      carts: Cart[];
      count: number;
      page: number;
      adminUIDs: string[];
    }>("/api/carts/list", {
      params: {
        page,
        pageSize: PAGE_SIZE,
        search: search || undefined,
        type: type || undefined,
        hasItems: hasItems ? "1" : undefined,
      },
    })
  ).then(({ data: res }) => {
    const adminUIDs = new Set<string>(res.adminUIDs || []);
    const userEmailByUID = new Map<string, string>(
      (res.carts || [])
        .map(c => [c.webUID, (c as any).webUser?.email] as [string, string])
        .filter(([uid, email]) => uid && email)
    );
    return {
      carts: res.carts || [],
      count: res.count || 0,
      page: res.page || page,
      adminUIDs,
      userEmailByUID,
    };
  });

  return { data };
}
